import styled from '@emotion/styled'

export const CheckmarkWrapper = styled.span`
  margin-left: auto;
`
